import { FC } from 'react'
import { Edit, SimpleForm, TextInput } from 'react-admin'
import { ToolFormFields } from '../../components'

const McpToolEdit: FC = () => (
  <Edit mutationMode="pessimistic">
    <SimpleForm>
      <TextInput source="server_id" label="data.serverId" fullWidth disabled />
      <ToolFormFields />
    </SimpleForm>
  </Edit>
)

export default McpToolEdit
